import ot from "../util/browser-detector.js";
import ue from "../models/braze-event.js";
import _t from "../models/identifier.js";
import {
  isArray as p,
  keys as or,
  validateValueIsFromEnum as F,
  values as Lt
} from "../util/code-utils.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { User } from "../User/index.js";
export const STORAGE_KEYS = {
  eu: {
    su: "ab.storage.userId",
    Jo: "ab.storage.deviceId",
    xh: "ab.storage.sessionId"
  },
  q: {
    Sa: "ab.test",
    Ta: "ab.storage.events",
    Aa: "ab.storage.attributes",
    Ia: "ab.storage.attributes.anonymous_user",
    Qo: "ab.storage.device",
    sa: "ab.storage.sdk_metadata",
    oa: "ab.storage.session_id_for_cached_metadata",
    vn: "ab.storage.pushToken",
    Di: "ab.storage.newsFeed",
    xi: "ab.storage.lastNewsFeedRefresh",
    P: "ab.storage.cardImpressions",
    hl: "ab.storage.serverConfig",
    Ka: "ab.storage.triggers",
    Ya: "ab.storage.triggers.ts",
    Gh: "ab.storage.messagingSessionStart",
    Yt: "ab.storage.cc",
    vs: "ab.storage.ccLastFullSync",
    ys: "ab.storage.ccLastCardUpdated",
    $: "ab.storage.ccClicks",
    O: "ab.storage.ccImpressions",
    K: "ab.storage.ccDismissals",
    Da: "ab.storage.lastDisplayedTriggerTimesById",
    Ga: "ab.storage.lastDisplayedTriggerTime",
    Na: "ab.storage.triggerFireInstancesById",
    Ln: "ab.storage.signature",
    As: "ab.storage.brazeSyncRetryCount",
    _s: "ab.storage.sdkVersion",
    di: "ab.storage.ff",
    vi: "ab.storage.ffLastRefreshAt"
  },
  ae: "ab.optOut"
};
export default class G {
  constructor(t, e) {
    (this.va = t), (this.Ma = e);
  }
  uu(t, e) {
    let s = e;
    null != e && e instanceof _t && (s = e.ss()), this.va.store(t, s);
  }
  Ca(t) {
    const e = this.tu(t);
    null != e && ((e.Wh = new Date().valueOf()), this.uu(t, e));
  }
  tu(t) {
    return _t.Pn(this.va.lr(t));
  }
  Jh(t) {
    this.va.remove(t);
  }
  bo(t) {
    if (null == t || 0 === t.length) return !1;
    p(t) || (t = [t]);
    let e = this.Ma.lr(STORAGE_KEYS.q.Ta);
    (null != e && p(e)) || (e = []);
    for (let s = 0; s < t.length; s++) e.push(t[s].ss());
    return this.Ma.store(STORAGE_KEYS.q.Ta, e);
  }
  qh(t) {
    return null != t && this.bo([t]);
  }
  ya() {
    let t = this.Ma.lr(STORAGE_KEYS.q.Ta);
    this.Ma.remove(STORAGE_KEYS.q.Ta), null == t && (t = []);
    const e = [];
    let s = !1,
      o = null;
    if (p(t))
      for (let s = 0; s < t.length; s++)
        ue.Ua(t[s]) ? e.push(ue.Pn(t[s])) : (o = s);
    else s = !0;
    if (s || null != o) {
      let n = "Stored events could not be deserialized as Events";
      s &&
        (n += ", was " + Object.prototype.toString.call(t) + " not an array"),
        null != o &&
          (n += ", value at index " + o + " does not look like an event"),
        (n +=
          ", serialized values were of type " +
          typeof t +
          ": " +
          JSON.stringify(t)),
        e.push(new ue(null, r.A.qs, new Date().valueOf(), null, { e: n }));
    }
    return e;
  }
  B(t, e) {
    return (
      !!F(
        STORAGE_KEYS.q,
        t,
        "StorageManager cannot store object.",
        "STORAGE_KEYS.OBJECTS"
      ) && this.Ma.store(t, e)
    );
  }
  I(t) {
    return (
      !!F(
        STORAGE_KEYS.q,
        t,
        "StorageManager cannot retrieve object.",
        "STORAGE_KEYS.OBJECTS"
      ) && this.Ma.lr(t)
    );
  }
  Xs(t) {
    return (
      !!F(
        STORAGE_KEYS.q,
        t,
        "StorageManager cannot remove object.",
        "STORAGE_KEYS.OBJECTS"
      ) && (this.Ma.remove(t), !0)
    );
  }
  clearData() {
    const t = or(STORAGE_KEYS.eu),
      e = or(STORAGE_KEYS.q);
    for (let e = 0; e < t.length; e++) {
      const s = t[e];
      this.va.remove(STORAGE_KEYS.eu[s]);
    }
    for (let t = 0; t < e.length; t++) {
      const s = e[t];
      this.Ma.remove(STORAGE_KEYS.q[s]);
    }
  }
  Fa(t) {
    return t || STORAGE_KEYS.q.Ia;
  }
  ga(t) {
    let e = this.Ma.lr(STORAGE_KEYS.q.Aa);
    null == e && (e = {});
    const s = this.Fa(t[User.Dn]);
    for (let r in t)
      r === User.Dn ||
        (null != e[s] && null != e[s][r]) ||
        this.mu(t[User.Dn], r, t[r]);
  }
  mu(t, e, s) {
    let r = this.Ma.lr(STORAGE_KEYS.q.Aa);
    null == r && (r = {});
    const o = this.Fa(t);
    let n = r[o];
    if (
      (null == n && ((n = {}), null != t && (n[User.Dn] = t)), e === User.lu)
    ) {
      null == n[e] && (n[e] = {});
      for (let t in s) n[e][t] = s[t];
    } else n[e] = s;
    return (r[o] = n), this.Ma.store(STORAGE_KEYS.q.Aa, r);
  }
  La() {
    const t = this.Ma.lr(STORAGE_KEYS.q.Aa);
    this.Ma.remove(STORAGE_KEYS.q.Aa);
    const e = [];
    for (let s in t) null != t[s] && e.push(t[s]);
    return e;
  }
  ou(t) {
    const e = this.Ma.lr(STORAGE_KEYS.q.Aa);
    if (null != e) {
      const s = this.Fa(null),
        r = e[s];
      null != r &&
        ((e[s] = void 0),
        this.Ma.store(STORAGE_KEYS.q.Aa, e),
        (r[User.Dn] = t),
        this.ga(r));
    }
    const s = this.tu(STORAGE_KEYS.eu.xh);
    let r = null;
    null != s && (r = s.iu);
    const o = this.ya();
    if (null != o)
      for (let e = 0; e < o.length; e++) {
        const s = o[e];
        null == s.userId && s.sessionId == r && (s.userId = t), this.qh(s);
      }
  }
  Ba() {
    return this.Ma.Pa;
  }
}
G._a = class {
  constructor(t) {
    (this._r = t), (this.Pa = ot.xa() ? 3 : 10);
  }
  Ja(t) {
    return t + "." + this._r;
  }
  store(t, e) {
    const s = { v: e };
    try {
      return localStorage.setItem(this.Ja(t), JSON.stringify(s)), !0;
    } catch (t) {
      return r.D.info("Storage failure: " + t.message), !1;
    }
  }
  lr(t) {
    try {
      const e = JSON.parse(localStorage.getItem(this.Ja(t)));
      return null == e ? null : e.v;
    } catch (t) {
      return r.D.info("Storage retrieval failure: " + t.message), null;
    }
  }
  remove(t) {
    try {
      localStorage.removeItem(this.Ja(t));
    } catch (t) {
      return r.D.info("Storage removal failure: " + t.message), !1;
    }
  }
};
G.ne = class {
  constructor(t, e) {
    (this._r = t), (this.ka = this.Va()), (this.za = 576e3), (this.Qa = !!e);
  }
  Ja(t) {
    return null != this._r ? t + "." + this._r : t;
  }
  Va() {
    let t = 0,
      e = document.location.hostname;
    const s = e.split("."),
      r = "ab._gd";
    for (; t < s.length - 1 && -1 === document.cookie.indexOf(r + "=" + r); )
      t++,
        (e = "." + s.slice(-1 - t).join(".")),
        (document.cookie = r + "=" + r + ";domain=" + e + ";");
    return (
      (document.cookie =
        r + "=;expires=" + new Date(0).toGMTString() + ";domain=" + e + ";"),
      e
    );
  }
  ie() {
    const t = new Date();
    return t.setTime(t.getTime() + 60 * this.za * 1e3), t.getFullYear();
  }
  Ha() {
    const t = Lt(STORAGE_KEYS.eu),
      e = document.cookie.split(";");
    for (let s = 0; s < e.length; s++) {
      let r = e[s];
      for (; " " === r.charAt(0); ) r = r.substring(1);
      let o = !1;
      for (let e = 0; e < t.length; e++)
        if (0 === r.indexOf(t[e])) {
          o = !0;
          break;
        }
      if (o) {
        const t = r.split("=")[0];
        -1 === t.indexOf("." + this._r) && this.Wa(t);
      }
    }
  }
  store(t, e) {
    this.Ha();
    const s = new Date();
    s.setTime(s.getTime() + 60 * this.za * 1e3);
    const o = "expires=" + s.toUTCString(),
      n = "domain=" + this.ka;
    let i;
    i = this.Qa ? e : encodeURIComponent(JSON.stringify(e));
    const a = this.Ja(t) + "=" + i + ";" + o + ";" + n + ";path=/";
    return a.length >= 4093
      ? (r.D.info(
          "Storage failure: string is " +
            a.length +
            " chars which is too large to store as a cookie."
        ),
        !1)
      : ((document.cookie = a), !0);
  }
  lr(t) {
    const e = [],
      s = this.Ja(t) + "=",
      o = document.cookie.split(";");
    for (let n = 0; n < o.length; n++) {
      let i = o[n];
      for (; " " === i.charAt(0); ) i = i.substring(1);
      if (0 === i.indexOf(s))
        try {
          let t;
          (t = this.Qa
            ? i.substring(s.length, i.length)
            : JSON.parse(decodeURIComponent(i.substring(s.length, i.length)))),
            e.push(t);
        } catch (e) {
          return (
            r.D.info("Storage retrieval failure: " + e.message),
            this.remove(t),
            null
          );
        }
    }
    return e.length > 0 ? e[e.length - 1] : null;
  }
  remove(t) {
    this.Wa(this.Ja(t));
  }
  Wa(t) {
    const e = t + "=;expires=" + new Date(0).toGMTString();
    (document.cookie = e), (document.cookie = e + ";path=/");
    const s = e + ";domain=" + this.ka;
    (document.cookie = s), (document.cookie = s + ";path=/");
  }
};
G.Oa = class {
  constructor() {
    (this.Xa = {}), (this.Za = 5242880), (this.Pa = 3);
  }
  store(t, e) {
    const s = { value: e },
      o = this.$a(e);
    return o > this.Za
      ? (r.D.info(
          "Storage failure: object is ≈" +
            o +
            " bytes which is greater than the max of " +
            this.Za
        ),
        !1)
      : ((this.Xa[t] = s), !0);
  }
  $a(t) {
    const e = [],
      s = [t];
    let r = 0;
    for (; s.length; ) {
      const t = s.pop();
      if ("boolean" == typeof t) r += 4;
      else if ("string" == typeof t) r += 2 * t.length;
      else if ("number" == typeof t) r += 8;
      else if ("object" == typeof t && -1 === e.indexOf(t)) {
        e.push(t);
        for (let e in t) s.push(t[e]);
      }
    }
    return r;
  }
  lr(t) {
    const e = this.Xa[t];
    return null == e ? null : e.value;
  }
  remove(t) {
    this.Xa[t] = null;
  }
};
G.wa = class {
  constructor(t, e, s) {
    (this.El = []),
      e && this.El.push(new G.ne(t)),
      s && this.El.push(new G._a(t)),
      this.El.push(new G.Oa(t));
  }
  store(t, e) {
    let s = !0;
    for (let r = 0; r < this.El.length; r++) s = this.El[r].store(t, e) && s;
    return s;
  }
  lr(t) {
    for (let e = 0; e < this.El.length; e++) {
      const s = this.El[e].lr(t);
      if (null != s) return s;
    }
    return null;
  }
  remove(t) {
    for (let e = 0; e < this.El.length; e++) this.El[e].remove(t);
  }
};
